import { ELanguage, LanguageActions, LanguageSelectors } from '@web_opxp/features';
import { all, call, fork, put, select, take, takeEvery } from 'redux-saga/effects';
import { ApiService, HttpError } from 'web_core_library';
import { ApiResponse } from '../../../core/apiResponse';
import { HttpStatusCode } from '../../../core/constants';
import * as ENV from '../../../core/env';
import LegalsService from '../services/LegalsService';
import * as ActionTypes from './actionTypes';
import * as Actions from './actions';
import { sortCountries } from './utils';

export function* startFeatureSaga() {
  yield call(ApiService.init, ENV.ApiUrl);
  yield call(LegalsService.init, ApiService);
  yield put(LanguageActions.initLanguage());
  yield take(LanguageActions.updateLanguage);
  let countriesData: ApiResponse;
  try {
    countriesData = new ApiResponse(yield call(LegalsService.getCountriesList));
  } catch (error) {
    countriesData = new ApiResponse((error as HttpError).baseError);
  }
  if (countriesData.isSuccess()) {
    const { countries, mostCommon } = sortCountries(countriesData.data);
    yield put(Actions.legalsUpdateCountriesAction(countries, mostCommon));
  } else {
    yield fork(handleApiError, countriesData);
  }
  yield put(Actions.translationsReadyAction());
}

export function* requestArticlesSaga(action: ActionTypes.ILegalsRequestAction) {
  let response: ApiResponse;
  try {
    const language: ELanguage | undefined = yield select(LanguageSelectors.getLanguage);
    response = new ApiResponse(
      yield call(LegalsService.requestTouArticles, action.articleAlias, action.country, language)
    );
  } catch (error) {
    response = new ApiResponse((error as HttpError).baseError);
  }
  yield fork(parseResponse, response);
}

export function* parseResponse(response: ApiResponse) {
  if (response.isSuccess()) {
    const articles = response.data.articles;
    yield put(Actions.legalsLoadedAction(articles));
    return;
  }
  yield fork(handleApiError, response);
}

function* handleApiError(response: ApiResponse) {
  let message = 'common:Errors.System';
  switch (response.status) {
    case HttpStatusCode.Unauthorized:
    case HttpStatusCode.TokenExpired:
      message = 'common:Errors.SessionExpired';
      break;
    case HttpStatusCode.ServiceUnavailable:
      message = 'common:Errors.System';
      break;
  }
  yield put(Actions.legalsFailedAction(message));
}

export default function* legalsAppRootSaga() {
  yield all([
    takeEvery(ActionTypes.LEGALS_INIT, startFeatureSaga),
    takeEvery(ActionTypes.LEGALS_REQUEST, requestArticlesSaga),
  ]);
}
